
import { Options, Vue } from "vue-class-component";
@Options({
  components: {}
})
export default class EnterOTP extends Vue {
  $keycloak: any; //globally defined in main.ts

  async created() {
    this.$keycloak.login("/leaveOTP");
  }
}
